var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      height: "100%",
      display: "flex",
      "flex-direction": "column"
    }
  }, [_c("div", [_c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("div", {
    staticClass: "table-page-search-wrapper"
  }, [_c("a-form-model", {
    ref: "formModel",
    attrs: {
      layout: "inline",
      model: _vm.form
    }
  }, [_c("a-row", {
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    attrs: {
      md: 8,
      sm: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("account.groupName"),
      prop: "groupName",
      rules: {
        required: true,
        message: _vm.$t("account.rule"),
        trigger: "blur"
      }
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 200,
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseinput")
    },
    model: {
      value: _vm.form.groupName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "groupName", $$v);
      },
      expression: "form.groupName"
    }
  })], 1)], 1)], 1)], 1)], 1)])], 1), _c("div", {
    staticStyle: {
      "margin-top": "24px",
      "flex-grow": "1"
    }
  }, [_c("a-card", {
    staticStyle: {
      height: "100%"
    },
    attrs: {
      bordered: false
    }
  }, [_c("a-row", {
    attrs: {
      type: "flex"
    }
  }, [_c("a-input-search", {
    staticStyle: {
      width: "400px"
    },
    attrs: {
      placeholder: _vm.$t("account.dyxContentPl")
    },
    model: {
      value: _vm.sarchValue,
      callback: function callback($$v) {
        _vm.sarchValue = $$v;
      },
      expression: "sarchValue"
    }
  }), _c("a-button", {
    staticStyle: {
      "margin-bottom": "5px",
      "margin-left": "auto"
    },
    attrs: {
      type: "primary",
      icon: "plus"
    },
    on: {
      click: function click($event) {
        return _vm.addEdit();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.add")))])], 1), _c("StandardTableVue", {
    attrs: {
      columns: _vm.columns,
      dataSource: _vm.data,
      loading: _vm.loadingTable,
      pagination: false
    },
    on: {
      change: _vm.changePage,
      showSizeChange: _vm.showSizeChange
    },
    scopedSlots: _vm._u([{
      key: "erpCustomerName",
      fn: function fn(_ref) {
        var record = _ref.record;
        return _c("div", {}, [_c("a", {
          staticStyle: {
            "text-decoration": "underline"
          },
          on: {
            click: function click($event) {
              return _vm.goProduct(record.erpCustomerId);
            }
          }
        }, [_vm._v(_vm._s(record.erpCustomerName))])]);
      }
    }, {
      key: "erpCustomerStatus",
      fn: function fn(_ref2) {
        var record = _ref2.record;
        return _c("span", {}, [_c("a-tag", {
          attrs: {
            color: record.erpCustomerStatus === 1 ? "blue" : "red"
          }
        }, [_vm._v(" " + _vm._s(record.erpCustomerStatus == 1 ? _vm.$t("public.normal") : record.erpCustomerStatus == 2 ? _vm.$t("publicuse.delete") : _vm.$t("overSell2")) + " ")])], 1);
      }
    }, {
      key: "action",
      fn: function fn(_ref3) {
        var record = _ref3.record;
        return _c("span", {}, [_c("a-popconfirm", {
          attrs: {
            title: _vm.$t("account.EnableMessage"),
            "ok-text": _vm.$t("yes"),
            "cancel-text": _vm.$t("no")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirmDelete(record);
            },
            cancel: _vm.cancelDelete
          }
        }, [_c("a", {
          attrs: {
            href: "javascript:;"
          },
          on: {
            click: function click($event) {
              return _vm.deleteGroup(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("account.delete")))])])], 1);
      }
    }])
  })], 1)], 1), _c("footer-tool-bar", [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loadingSave
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.save")))])], 1), _c("selectGroupVue", {
    ref: "selectModal",
    attrs: {
      alreadySelect: _vm.alreadySelect
    },
    on: {
      confirmProduct: _vm.confirmProduct
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };